import { render, staticRenderFns } from "./loginnew.vue?vue&type=template&id=2dcd2155&scoped=true&"
import script from "./loginnew.vue?vue&type=script&lang=js&"
export * from "./loginnew.vue?vue&type=script&lang=js&"
import style0 from "./loginnew.vue?vue&type=style&index=0&id=2dcd2155&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd2155",
  null
  
)

export default component.exports